/** Bases that use passenger SMS reservation confirmation (portal Status column + API). */
export const PASSENGER_RESERVATION_SMS_CONFIRMATION_ALLOW_DB_NAMES = ['omngateway2'];

export const isPassengerReservationSmsConfirmationAllowed = dbname =>
  !!dbname && PASSENGER_RESERVATION_SMS_CONFIRMATION_ALLOW_DB_NAMES.includes(dbname);
